// extracted by mini-css-extract-plugin
export default {"actions":"gHll5u"};